import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';

import { TypeInvoiceService } from '../../../../service/invoice/TypeInvoiceService';
import { TenantInvoiceSettingMasterService } from '../../../he-thong/cau-hinh-hoa-don/TenantInvoiceSettingMasterService';
import { FormatDisplay } from '../../../../shared/format';
import { BusinessLocationService } from '../../../danh-muc/dia-diem-kinh-doanh/BusinessLocationService';
import { AppStorage } from '../../../../service/UserStorage';
import EventEmitter from '../../../../utils/EventEmitter';

export const INVOICE_TYPES_WITH_BUSINESS_LOCATION = ['2', '5', '6', '7'];

export const getIsHouseholdBusinessFromStorage = (): boolean => {
  const flag = AppStorage.get('isHouseholdBusiness');
  if (flag === 'true') return true;
  if (flag === 'false') return false;
  const raw = AppStorage.get('tenantInfo');
  if (!raw) return false;
  try {
    return JSON.parse(raw).isHouseholdBusiness === true;
  } catch {
    return false;
  }
};

export const Menu1 = (props) => {

  const { attribute, changeAttribute, dispatchEvent } = props;

  const { search } = useLocation();

  const [tenantStorageRev, setTenantStorageRev] = useState(0);
  useEffect(() => {
    const onTenantInfo = () => setTenantStorageRev((n) => n + 1);
    EventEmitter.on('changeTenantInfo', onTenantInfo);
    return () => {
      EventEmitter.off('changeTenantInfo', onTenantInfo);
    };
  }, []);

  const [mauSo1Items, setMauSo1Items] = useState([]);
  const [mauSo4Items, setMauSo4Items] = useState([
    { value: 'T', label: 'T - Đơn vị tự đăng ký sử dụng với cơ quan thuế' },
    { value: 'D', label: 'D - Hóa đơn bán tài sản công, bán hàng dự trữ quốc gia hoặc hóa đơn đặc thù' },
    { value: 'L', label: 'L - Hóa đơn điện tử của cơ quan thuế cấp theo từng lần phát sinh' },
    { value: 'M', label: 'M - Hóa đơn điện tử được khởi tạo từ máy tính tiền' },
    { value: 'N', label: 'N - Phiếu xuất kho kiêm vận chuyển nội bộ điện tử' },
    { value: 'B', label: 'B - Phiếu xuất kho hàng gửi bán đại lý điện tử' },
    { value: 'G', label: 'G - Tem, vé, thẻ điện tử là hóa đơn giá trị gia tăng' },
    { value: 'H', label: 'H - Tem, vé, thẻ điện tử là hóa đơn bán hàng' }
  ]);
  const [typeCompany, setTypeCompany] = useState([
    { value: 0, label: 'Thông thường' },
    { value: 1, label: 'Xăng dầu' },
    { value: 2, label: 'Vàng bạc' },
    { value: 3, label: 'Vé Máy bay' },
    { value: 4, label: 'Hóa đơn mua bán xe' },
    { value: 5, label: 'Hóa đơn dịch vụ vận chuyển' },
    { value: 6, label: 'Hóa đơn dịch vụ vận chuyển trên nền tảng số' },
  ]);
  const [businessLocations, setBusinessLocations] = useState([]);
  const [settings, setSetting] = useState([]);
  

  useEffect(() => {
    if (attribute.invoiceType && attribute.invoiceType.id) {
      TenantInvoiceSettingMasterService.getList({ typeInvoiceId: attribute.invoiceType.id, maxResultCount: 1000 }).then(({ items }) => {
        const _settings = [];
        for (const item of items) {
          _settings.push({ value: item.id, label: item.name });
        }
        setSetting(_settings);
      });
    }
  }, [attribute.invoiceType]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (attribute.invoiceType) {
      const symbolCode = `${attribute.invoiceType.type}${attribute.mauSo2}${attribute.mauSo3}${attribute.mauSo4}${attribute.mauSo5}`;
      changeAttribute('symbolCode', symbolCode);

      const event = new CustomEvent('setText', {
        detail: { selector: `[databind='InvoiceSerial']`, value: symbolCode }
      });
      dispatchEvent(event);
    }
  }, [attribute.invoiceType, attribute.mauSo2, attribute.mauSo3, attribute.mauSo4, attribute.mauSo5]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    BusinessLocationService.getList({ maxResultCount: 1000 }).then(({ items }) => {
      const _businessLocations = [];
      for (const item of items) {
        _businessLocations.push({ value: item.id, label: item.name });
      }
      setBusinessLocations(_businessLocations);
    });
  }, []);

  const year = new Date().getFullYear();
  const yearStr = year.toString();
  const yearAbb = parseInt(yearStr[yearStr.length - 2] + yearStr[yearStr.length - 1]);
  const mauSo3Items = [
    { value: `${yearAbb + 1}`, label: `${yearAbb + 1} - ${year + 1}` },
    { value: `${yearAbb}`, label: `${yearAbb} - ${year}` },
    { value: `${yearAbb - 1}`, label: `${yearAbb - 1} - ${year - 1}` }
  ];
  useEffect(() => {
    TypeInvoiceService.getList({}).then(({ items }) => {
      const _mauSo1Items = [];
      items.forEach((item) => {
        _mauSo1Items.push(Object.assign(item, { label: `${item.type} - ${item.name}` }));
      });
      changeAttribute('mauSo3', `${yearAbb}`);
      setMauSo1Items(_mauSo1Items);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (search && mauSo1Items && mauSo1Items.length) {
      const params = new URLSearchParams(search);
      mauSo1Items.forEach(mauSo1Item => {
        if (params.get('invoiceType') === mauSo1Item.id) {
          changeAttribute('invoiceType', mauSo1Item);
        }
      });
    }
  }, [search, mauSo1Items]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (attribute.invoiceType && !props.update) {
      let _mauSo4Items = [];
      switch (attribute.invoiceType.reportName) {
        case 'HDGTGT':
        case 'HDBHang':
          _mauSo4Items.push(...[
            { value: 'T', label: 'T - Đơn vị tự đăng ký sử dụng với cơ quan thuế' },
            { value: 'L', label: 'L - Hóa đơn điện tử của cơ quan thuế cấp theo từng lần phát sinh' },
          ]);
          break;
        case 'HDGTGT_MTT':
        case 'HDBHang_MTT':
          _mauSo4Items.push(...[
            { value: 'M', label: 'M - Hóa đơn điện tử được khởi tạo từ máy tính tiền' }
          ]);
          break;
        case 'HDBTSCong':
        case 'HDBHDTQGia':
          _mauSo4Items.push(...[
            { value: 'D', label: 'D - Hóa đơn bán tài sản công, bán hàng dự trữ quốc gia hoặc hóa đơn đặc thù' }
          ]);
          break;
        case 'HDKhac':
          _mauSo4Items.push(...[
            { value: 'G', label: 'G - Tem, vé, thẻ điện tử là hóa đơn giá trị gia tăng' },
            { value: 'H', label: 'H - Tem, vé, thẻ điện tử là hóa đơn bán hàng' },
          ]);
          break;
        case 'HDKhac_MTT':
          _mauSo4Items.push(...[
            { value: 'M', label: 'M - Hóa đơn điện tử được khởi tạo từ máy tính tiền' }
          ]);
          break;
        case 'PXKhoNoiBo':
          _mauSo4Items.push(...[
            { value: 'N', label: 'N - Phiếu xuất kho kiêm vận chuyển nội bộ điện tử' }
          ]);
          break;
        case 'PXKho':
          _mauSo4Items.push(...[
            { value: 'B', label: 'B - Phiếu xuất kho hàng gửi bán đại lý điện tử' }
          ]);
          break;
      }
      setMauSo4Items(_mauSo4Items);
      changeAttribute('mauSo4', _mauSo4Items[0].value);
    }
  }, [attribute.invoiceType]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (attribute.originSymbolCode) {
      const { originSymbolCode } = attribute;
      changeAttribute('mauSo2', originSymbolCode[1]);
      changeAttribute('mauSo3', `${originSymbolCode[2]}${originSymbolCode[3]}`);
      changeAttribute('mauSo4', `${originSymbolCode[4]}`);
      changeAttribute('mauSo5', `${originSymbolCode[5]}${originSymbolCode[6]}`);
    }
  }, [attribute.originSymbolCode]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (attribute.originInvoiceType && mauSo1Items) {
      const { originInvoiceType } = attribute;
      let invoiceType;
      mauSo1Items.forEach(item => {
        if (originInvoiceType === item.id) {
          invoiceType = item;
        }
      });
      changeAttribute('invoiceType', invoiceType);
    }
  }, [attribute.originInvoiceType, mauSo1Items]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let event;
    if (attribute.mauSo2 === 'C') {
      event = new CustomEvent('setCss', {
        detail: { selector: '.macqt', property: 'display', value: '' }
      });
      changeAttribute('signOnly', false);
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '.macqt', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }, [attribute.mauSo2]); // eslint-disable-line react-hooks/exhaustive-deps

  const mauSo2Items = [
    { value: 'C', label: 'C - Có mã' },
    { value: 'K', label: 'K - Không mã' }
  ];

  const fontStyleItems = [
    { value: 'Time New Roman', label: 'Time New Roman' },
    { value: 'Calibri', label: 'Calibri' },
    { value: 'Arial', label: 'Arial' }
  ];
  // @ts-ignore
  const sizes = [...Array(15).keys()].map(i => i + 10);
  const fontSizeItems = [];
  sizes.forEach((size) => {
    fontSizeItems.push({ value: size, label: size });
  });

  const onSongNguChange = (value) => {
    changeAttribute('songNgu', value);

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '.songNgu', property: 'display', value: '' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '.songNgu', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }

  const onColorValueChange = (value) => {
    changeAttribute('colorText', value);

    let event = new CustomEvent('setCss', {
      detail: { selector: '.chinhSua', property: 'color', value: `${value}` }
    });
    dispatchEvent(event);

    event = new CustomEvent('setCss', {
      detail: { selector: '.hoadonmau .border-all, .hoadonmau .border-lr, .hoadonmau .item-invoice td, .border-top-hd', property: 'border-color', value: `${value}` }
    });
    dispatchEvent(event);
  }

  const onFontFamilyChange = (value) => {
    changeAttribute('fontStyle', value);

    const event = new CustomEvent('setCss', {
      detail: { selector: '#vong1', property: 'font-family', value }
    });
    dispatchEvent(event);
  }

  const onFontSizeChange = (value) => {
    changeAttribute('fontSize', value);

    let event = new CustomEvent('setCss', {
      detail: { selector: '#vong1', property: 'font-size', value: `${value}px` }
    });
    dispatchEvent(event);

    event = new CustomEvent('setCss', {
      detail: { selector: '.chinhSua', property: 'font-size', value: `${value}px` }
    });
    dispatchEvent(event);
  }

  const onGachChanChange = (value) => {
    changeAttribute('gachChan', value);

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: {
          selector: '.thongTinNguoiMua .chinhSua.value', properties: [
            { property: 'border-width', value: '1px' },
            { property: 'border-bottom-style', value: 'dotted' },
            { property: 'border-bottom-color', value: 'initial' }
          ]
        }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: {
          selector: '.thongTinNguoiMua .chinhSua.value', properties: [
            { property: 'border-width', value: '0' }
          ]
        }
      });
    }
    dispatchEvent(event);
  }

  const onBossSignChange = (value) => {
    changeAttribute('bossSign', value);

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '#signature-hd-thutruong', property: 'display', value: 'table-cell' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '#signature-hd-thutruong', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }

  const onFormatHtmlChange = (value) => {
    changeAttribute('formatHtml', value);

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '#signature-hd-thutruong', property: 'display', value: 'table-cell' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '#signature-hd-thutruong', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }

  const onDongKeChange = (value) => {
    changeAttribute('dongKe', value);

    if (value) {
      onBorderStyleChange(attribute.borderStyle);
    } else {
      const event = new CustomEvent('setCss', {
        detail: { selector: '.bordermo1', property: 'border-bottom', value: 'none' }
      });
      dispatchEvent(event);
    }
  }

  const onKyHieuCotChange = (value) => {
    changeAttribute('kyHieuCot', value);

    let event;
    if (value) {
      event = new CustomEvent('setCss', {
        detail: { selector: '#sd-kh', property: 'display', value: 'table-row' }
      });
    } else {
      event = new CustomEvent('setCss', {
        detail: { selector: '#sd-kh', property: 'display', value: 'none' }
      });
    }
    dispatchEvent(event);
  }

  const onBorderStyleChange = (value) => {
    changeAttribute('borderStyle', value);

    let event;
    switch (value) {
      case 'dashed':
        event = new CustomEvent('setCss', {
          detail: { selector: '.bordermo1', property: 'border-bottom', value: '1px dashed rgb(204, 204, 204)' }
        });
        break;
      case 'solid':
        event = new CustomEvent('setCss', {
          detail: { selector: '.bordermo1', property: 'border-bottom', value: '1px solid rgb(204, 204, 204)' }
        });
        break;
    }
    if (event) {
      dispatchEvent(event);
    }
  }

  const openInvoiceSetting = () => {
    if (attribute.tenantInvoiceSettingMasterId) {
      window.location.hash = `/he-thong/cau-hinh-hoa-don/update/${attribute.tenantInvoiceSettingMasterId}`;
    }
  }

  const invoiceTypePrefix = attribute.invoiceType?.type != null ? String(attribute.invoiceType.type) : '';
  void tenantStorageRev;
  const isHouseholdBusinessTenant = getIsHouseholdBusinessFromStorage();
  const showBusinessLocationField =
    INVOICE_TYPES_WITH_BUSINESS_LOCATION.includes(invoiceTypePrefix) && isHouseholdBusinessTenant;

  return (
    <div className="p-fluid">
      <div className="field grid">
        <label htmlFor="name3" className="col-12 mb-2 md:col-2 md:mb-0">Mẫu số</label>
        <div className="col-12 md:col-10">
          <div className="grid">
            <div className="col-fixed" style={{ width: '70px' }}>
              <Dropdown className="p-inputtext-sm" disabled value={attribute.invoiceType} options={mauSo1Items} onChange={(e) => changeAttribute('invoiceType', e.value)}
                valueTemplate={(option) => {
                  return option ? option.type : '-'
                }} />
            </div>
            <div className="col-fixed" style={{ width: '75px' }}>
              <Dropdown className="p-inputtext-sm" value={attribute.mauSo2} options={mauSo2Items} onChange={(e) => changeAttribute('mauSo2', e.value)}
                valueTemplate={(option) => {
                  return option ? option.value : ''
                }} />
            </div>
            <div className="col-fixed" style={{ width: '75px' }}>
              <Dropdown className="p-inputtext-sm" value={attribute.mauSo3} options={mauSo3Items} onChange={(e) => changeAttribute('mauSo3', e.value)}
                valueTemplate={(option) => {
                  return option ? option.value : ''
                }} />
            </div>
            <div className="col-fixed" style={{ width: '75px' }}>
              <Dropdown className="p-inputtext-sm" value={attribute.mauSo4} options={mauSo4Items} onChange={(e) => changeAttribute('mauSo4', e.value)}
                valueTemplate={(option) => {
                  return option ? option.value : ''
                }} />
            </div>
            <div className="col-fixed" style={{ width: '75px' }}>
              <InputText className="p-inputtext-sm" keyfilter="alpha" value={attribute.mauSo5} onChange={(e) => changeAttribute('mauSo5', e.target.value.toUpperCase())}
                maxLength={2} />
            </div>
          </div>
        </div>
      </div>
      <div className="field grid">
        <label htmlFor="symbolCode" className="col-12 mb-2 md:col-2 md:mb-0">Ký hiệu</label>
        <div className="col-12 md:col-4">
          <InputText id="symbolCode" type="text" className="p-inputtext-sm" value={attribute.symbolCode} onChange={(e) => changeAttribute('symbolCode', e.target.value)} disabled />
        </div>
        <label htmlFor="symbolCode" className="col-12 mb-2 md:col-2 md:mb-0" onClick={openInvoiceSetting}>Cấu hình</label>
        <div className="col">
          <Dropdown className="p-inputtext-sm" value={attribute.tenantInvoiceSettingMasterId} onChange={(e) => changeAttribute('tenantInvoiceSettingMasterId', e.value)} options={settings} />
        </div>

      </div>
      <div className="field grid">
        <label htmlFor="typeCompany" className="col-12 mb-4 md:col-4 md:mb-0">Loại doanh nghiệp</label>
        <div className="col-12 md:col-8">
          <Dropdown className="p-inputtext-sm" value={attribute.typeCompany} onChange={(e) => changeAttribute('typeCompany', e.value)} options={typeCompany} />
        </div>
      </div>
      {showBusinessLocationField && (
        <div className="field grid">
          <label htmlFor="businessLocationId" className="col-12 mb-4 md:col-4 md:mb-0">Địa điểm kinh doanh</label>
          <div className="col-12 md:col-8">
            <Dropdown inputId="businessLocationId" className="p-inputtext-sm" value={attribute.businessLocationId} onChange={(e) => changeAttribute('businessLocationId', e.value)} options={businessLocations} />
          </div>
        </div>
      )}
      <hr />
      <div className="field grid">
        <label className="col-12 mb-2 md:col-4 md:mb-0">Tùy chỉnh ngôn ngữ</label>
        <div className="col-12 md:col-8">
          <div className="field-checkbox mb-0">
            <Checkbox inputId="songNgu" checked={attribute.songNgu} onChange={e => onSongNguChange(e.checked)} />
            <label htmlFor="songNgu">Song ngữ (Việt - Anh)</label>
          </div>
        </div>
      </div>
      <hr />

      <div className="field grid">
        <label className="col-12 mb-2 md:col-4 md:mb-0">Tùy chỉnh ký</label>
        <div className="col-12 md:col-8">
          <div className="field-radiobutton">
            <RadioButton inputId="signOnly" name="signOnly" value={false} checked={!attribute.signOnly} onChange={e => changeAttribute('signOnly', e.value)}
              disabled={attribute.mauSo2 === 'C'} />
            <label htmlFor="signOnly">Ký hóa đơn gửi ngay CQT</label>
          </div>
          <div className="field-radiobutton">
            <RadioButton inputId="signOnly-false" name="signOnly" value={true} checked={attribute.signOnly} onChange={e => changeAttribute('signOnly', e.value)}
              disabled={attribute.mauSo2 === 'C'} />
            <label htmlFor="signOnly-false">Ký hóa đơn gửi bảng tổng hợp cuối kỳ</label>
          </div>
        </div>
      </div>

      <hr />
      <div className="field grid">
        <label htmlFor="colorText" className="col-12 mb-2 md:col-4 md:mb-0">Tùy chỉnh màu</label>
        <div className="col-12 md:col-8">
          <input id="colorText" type="color" value={attribute.colorText} onChange={(e) => onColorValueChange(e.target.value)} />
        </div>
      </div>
      <hr />
      <div className="field grid">
        <label className="col-12 mb-2 md:col-4 md:mb-0">Tùy chỉnh font</label>
        <div className="col-12 md:col-8">
          <div className="grid">
            <div className="col-fixed" style={{ width: '180px' }}>
              <Dropdown className="p-inputtext-sm" value={attribute.fontStyle} onChange={(e) => onFontFamilyChange(e.value)} options={fontStyleItems} />
            </div>
            <div className="col-fixed" style={{ width: '90px' }}>
              <Dropdown className="p-inputtext-sm" value={attribute.fontSize} onChange={(e) => onFontSizeChange(e.value)} options={fontSizeItems} />
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="field grid">
        <label className="col-12 mb-2 md:col-4 md:mb-0">Tùy chỉnh người mua</label>
        <div className="col-12 md:col-8">
          <div className="field-checkbox mb-0">
            <Checkbox inputId="gachChan" checked={attribute.gachChan} onChange={e => onGachChanChange(e.checked)} />
            <label htmlFor="gachChan">Giá trị người mua có gạch chân</label>
          </div>
        </div>
      </div>
      <hr />
      <div className="field grid">
        <label className="col-12 mb-2 md:col-4 md:mb-0 align-items-start">Tùy chỉnh bảng</label>
        <div className="col-12 md:col-8">
          <div className="field field-checkbox">
            <Checkbox inputId="dongKe" checked={attribute.dongKe} onChange={e => onDongKeChange(e.checked)} />
            <label htmlFor="dongKe">Bảng có dòng kẻ hàng</label>
          </div>
          <div className="grid mt-4">
            <div className="col-1" />
            <div className="col-11">
              <div className="grid">
                <div className="col-12 md:col-6">
                  <div className="field-radiobutton">
                    <RadioButton inputId="borderStyle1" name="borderStyle" value="dashed" checked={attribute.borderStyle === 'dashed'} onChange={e => onBorderStyleChange(e.value)} />
                    <label htmlFor="borderStyle1">..............</label>
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div className="field-radiobutton">
                    <RadioButton inputId="borderStyle2" name="borderStyle" value="solid" checked={attribute.borderStyle === 'solid'} onChange={e => onBorderStyleChange(e.value)} />
                    <label htmlFor="borderStyle2">_________</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="field field-checkbox mt-2">
            <Checkbox inputId="kyHieuCot" checked={attribute.kyHieuCot} onChange={e => onKyHieuCotChange(e.checked)} />
            <label htmlFor="kyHieuCot">Thiết lập số dòng ký hiệu cột</label>
          </div>
          <div className="field grid">
            <label className="col-12 mb-2 md:col-5 md:mb-0">Số dòng trắng</label>
            <div className="col-12 md:col-5">
              <InputNumber locale={FormatDisplay.locales} className="p-inputtext-sm" value={attribute.numberRecord} onChange={e => changeAttribute('numberRecord', e.value)} showButtons />
            </div>
          </div>
          <div className="field grid">
            <label className="col-12 mb-2 md:col-5 md:mb-0">Số dòng hóa đơn nhiều trang</label>
            <div className="col-12 md:col-5">
              <InputNumber locale={FormatDisplay.locales} className="p-inputtext-sm" value={attribute.numberRecordMutile} onChange={e => changeAttribute('numberRecordMutile', e.value)} showButtons />
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="field grid">
        <label className="col-12 mb-2 md:col-4 md:mb-0">Tùy chỉnh nhãn ký</label>
        <div className="col-12 md:col-8">
          <div className="field-checkbox mb-0">
            <Checkbox inputId="bossSign" checked={attribute.bossSign} onChange={e => onBossSignChange(e.checked)} />
            <label htmlFor="bossSign">Chữ ký thủ trưởng</label>
          </div>
        </div>
      </div>
      <hr />
      <div className="field grid">
        <label className="col-12 mb-2 md:col-4 md:mb-0">Hóa đơn gửi email</label>
        <div className="col-12 md:col-8">
          <div className="field-checkbox mb-0">
            <Checkbox inputId="formatHtml" checked={attribute.formatHtml} onChange={e => onFormatHtmlChange(e.checked)} />
            <label htmlFor="formatHtml">Định dạng Html</label>
          </div>
        </div>
      </div>
    </div>
  );
}
